import React, { useEffect, useState } from "react";
import api from "@/lib/api";

export const ResultsOverview = () => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/admin/results-overview").then((r) => setRows(r.data)).catch(() => setRows([])); }, []);
  if (!rows) return null;
  return (
    <section className="card-warm p-5 mb-6 overflow-x-auto" data-testid="admin-results-overview">
      <div className="eyebrow mb-3">Results overview</div>
      <table className="w-full text-sm min-w-[640px]">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider text-zinc-500">
            {["Course", "Enrolled", "Sat", "Passed", "Pass rate", "Awaiting grading", "Certificates to send"].map((h) => <th key={h} className="py-2 pr-3">{h}</th>)}
          </tr>
        </thead>
        <tbody className="divide-y divide-[var(--border-warm)]">
          {rows.map((r) => (
            <tr key={r.course_id} data-testid={`overview-row-${r.course_code}`}>
              <td className="py-2 pr-3"><b>{r.course_code}</b><div className="text-xs text-zinc-500">{r.course_title}</div></td>
              <td className="py-2 pr-3">{r.enrolled}</td>
              <td className="py-2 pr-3">{r.candidates}</td>
              <td className="py-2 pr-3">{r.passed}</td>
              <td className="py-2 pr-3 font-semibold">{r.pass_rate != null ? `${r.pass_rate}%` : "-"}</td>
              <td className="py-2 pr-3">{r.awaiting_grading}</td>
              <td className={`py-2 pr-3 font-semibold ${r.certificates_to_send ? "text-[var(--terracotta)]" : ""}`} data-testid={`overview-certs-${r.course_code}`}>{r.certificates_to_send}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
};
